import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAsyncEffect } from 'rooks';

import { useTheme } from '@/helpers/theme';
import Loader from '@/components/common/Loader';
import { setTenantId } from '@/helpers/api';
import { useActivateTenantUser } from '@/data/tenantUser';
import { getToken } from '@/helpers/api';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import Error from '@/components/common/Error';
import { Button } from '@/components/ui/button';
import HorizontalLogo from '@/components/common/HorizontalLogo';

const Page = () => {
  useTheme();
  const { tenantUserActivationId } = useParams();
  const activateTenantUser = useActivateTenantUser();
  const navigate = useNavigate();
  const [apiError, setApiError] = useState('');

  useAsyncEffect(async () => {
    try {
      setApiError('');
      const tenantUser = await activateTenantUser(tenantUserActivationId);
      setTenantId(tenantUser.tenant.id);
      if (getToken()) {
        navigate('/tenant');
      } else {
        navigate('/login');
      }
    } catch (err) {
      setApiError(err.message);
    }
  }, []);

  if (apiError) {
    return (
      <div className="flex items-center justify-center p-4 h-screen w-screen bg-topography bg-login-bg bg-blend-overlay">
        <Card className="w-screen max-w-[380px]">
          <CardHeader>
            <div className="p-6">
              <HorizontalLogo />
            </div>
            <CardTitle>Activation Error</CardTitle>
            <CardDescription>
              There was an error activating your account
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-2">
            <Error error={apiError} />
          </CardContent>
          <CardFooter>
            <Button
              variant="outline"
              onClick={() => navigate('/login')}
              className="w-full"
            >
              Go to Login
            </Button>
          </CardFooter>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4 h-screen w-screen bg-topography bg-login-bg bg-blend-overlay">
      <Loader />
    </div>
  );
};

export default Page;
